module.exports = __webpack_public_path__ + "static/img/banner2.373be3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners_new/banner2.png
// module id = CpB5
// module chunks = 6